// =============================================
// BIJLEEX — INDEX PAGE JS (lightweight)
// Heavy full-screen energy canvas removed for performance.
// Motion is now handled by GPU-friendly CSS (electric lanes, arc rings).
// =============================================

// ---- COUNTDOWN TIMER ----
const countdownWrap = document.querySelector('.countdown-wrap');
if (countdownWrap) {
  const launchDate = new Date(countdownWrap.dataset.launchDate || '2026-09-01T00:00:00+01:00').getTime();
  const els = {
    days: document.getElementById('days'),
    hours: document.getElementById('hours'),
    minutes: document.getElementById('minutes'),
    seconds: document.getElementById('seconds')
  };
  const pad = n => String(Math.max(0, n)).padStart(2, '0');

  function updateCountdown() {
    const diff = launchDate - Date.now();
    if (diff <= 0) {
      Object.values(els).forEach(el => { if (el) el.textContent = '00'; });
      return;
    }
    if (els.days) els.days.textContent = pad(Math.floor(diff / 86400000));
    if (els.hours) els.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
    if (els.minutes) els.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
    if (els.seconds) els.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

// ---- NOTIFY FORM (progressive enhancement) ----
function handleNotify(e) {
  e.preventDefault();
  const form = e.target;
  form.style.display = 'none';
  const success = document.getElementById('notifySuccess');
  if (success) success.classList.add('show');
}
